// Mock Auth Service

import apiClient from './api'

export default {
    login(credentials) {
        return apiClient.post('/auth/login', credentials)
            .then(response => {
                const token = response.data.token
                const user = response.data.user
                if (token) {
                    localStorage.setItem('token', token)
                }
                return user
            })
    },

    register(userData) {
        console.log('📝 Registering user:', userData.email)
        return apiClient.post('/auth/register', userData)
            .then(response => {
                console.log('✅ Registration response:', response.status, response.data)
                const token = response.data.token
                const user = response.data.user
                if (token) {
                    localStorage.setItem('token', token)
                    console.log('🔑 Token saved to localStorage')
                }
                return user
            })
            .catch(error => {
                console.error('❌ Registration error:', error.response?.status, error.response?.data)
                throw error
            })
    },

    logout() {
        const token = localStorage.getItem('token')

        // Only call backend logout if we have a valid token
        if (token) {
            return apiClient.post('/auth/logout')
                .catch(() => {
                    // Ignore errors (e.g., 401 if token already expired)
                    console.log('Logout API call failed, but clearing local session anyway')
                })
                .finally(() => {
                    localStorage.removeItem('token')
                })
        } else {
            // No token, just clear localStorage
            localStorage.removeItem('token')
            return Promise.resolve()
        }
    },

    checkSession() {
        const token = localStorage.getItem('token')
        if (!token) {
            return Promise.reject(new Error('No token found'))
        }
        return apiClient.get('/auth/me')
            .then(response => response.data)
            .catch(error => {
                localStorage.removeItem('token')
                throw error
            })
    },

    forgotPassword(email) {
        return apiClient.post('/auth/password/forgot', { email })
            .then(response => response.data)
    },

    resetPassword(data) {
        return apiClient.post('/auth/password/reset', data)
            .then(response => response.data)
    },
}
